"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Localization_1 = require("../../../constants/Localization");
var i18n_1 = __importDefault(require("../../../i18n"));
var react_redux_1 = require("react-redux");
var loginSlice_1 = require("../../../features/login/loginSlice");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var classnames_1 = __importDefault(require("classnames"));
var SubHeader = function (_a) {
    var isAnnouncementPage = _a.isAnnouncementPage;
    var t = react_i18next_1.useTranslation('common').t;
    var isLoginOpen = react_redux_1.useSelector(loginSlice_1.selectLoginModalIsOpen);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    return (react_1.default.createElement(react_1.default.Fragment, null, !isAnnouncementPage && !isLoginOpen && (react_1.default.createElement("div", { className: "sub" },
        react_1.default.createElement("div", { className: "sub-container" },
            react_1.default.createElement(react_router_dom_1.Link, { className: classnames_1.default('options', {
                    sell: (location === null || location === void 0 ? void 0 : location.pathname.search(Localization_1.SellPagePrefix[currentLanguage].sell)) > -1,
                }), to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell +
                    Localization_1.SearchPageNavigation[currentLanguage].sell }, t('POST_PREVIEW.SELL')),
            react_1.default.createElement("span", { className: "separator" }),
            react_1.default.createElement(react_router_dom_1.Link, { className: classnames_1.default('options', {
                    rent: (location === null || location === void 0 ? void 0 : location.pathname.search(Localization_1.SellPagePrefix[currentLanguage].rent)) > -1,
                }), to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].rent +
                    Localization_1.SearchPageNavigation[currentLanguage].rent }, t('POST_PREVIEW.RENT')))))));
};
exports.default = SubHeader;
